//import _ from 'lodash';
import {
	USER_REQUEST,
	USER_RESPONSE,
	USER_FAILURE,
	USER_REQUEST_RESET,
	USER_RESPONSE_RESET,
	USER_FAILURE_RESET
} from './actions';
const getEmailInitialState = {
	user: [],
	error: null,
	isLoading: false
};
export const user = (state = getEmailInitialState, action) => {
	switch (action.type) {
		case USER_REQUEST:
			return {
				...state,
				error: null
			};
		case USER_RESPONSE:
			return {
				...state,
				user: action.user
			};
		case USER_FAILURE:
			return {
				...state,
				error: action.error
			};
		default:
			return state;
	}
};

const resetPasswordlInitialState = {
	resetpassword: [],
	error: null,
	isLoading: false
};
export const resetpassword = (state = resetPasswordlInitialState, action) => {
	switch (action.type) {
		case USER_REQUEST_RESET:
			return {
				...state,
				error: null
			};
		case USER_RESPONSE_RESET:
			return {
				...state,
				resetpassword: action.resetpassword
			};
		case USER_FAILURE_RESET:
			return {
				...state,
				error: action.error
			};
		default:
			return state;
	}
};
